import { render, staticRenderFns } from "./OrderType.vue?vue&type=template&id=e0505a54&scoped=true&"
import script from "./OrderType.vue?vue&type=script&lang=js&"
export * from "./OrderType.vue?vue&type=script&lang=js&"
import style0 from "./OrderType.vue?vue&type=style&index=0&id=e0505a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0505a54",
  null
  
)

export default component.exports